import {
    TableCell,
    TableRow,
    Theme,
    Typography
} from "@mui/material";
import { FundHousePerformanceData } from "../types";
import { formatCurrency } from "../../../../utils/utilityFunctions";
import { useDispatch, useSelector } from "react-redux";
import { RootStateType } from "../../../../redux-store/reducers";
import { useHistory } from "react-router";
import { storeSelectedPortfolio } from '../../../../redux-store/actions/portfolioFilter'

export default function FundsDataTable({ data }: { data: FundHousePerformanceData[] }): JSX.Element {
    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);
    const history = useHistory();
    const { pathname } = history.location;
    const isInvestorProfilePage = pathname.includes('investor-profile') || pathname.includes('investor-dashboard');
    const dispatch = useDispatch();
    const handleClientClick = (obj: FundHousePerformanceData) => {
        dispatch(storeSelectedPortfolio({label: obj?.customerName ?? "", value: obj?.portfolio ?? ""}))
        history.push(
            `/investor-profile/${obj?.customerName ?? ""}/pms?tab=Overview`,
            {
                clientCode: obj?.customer,
                portfolioId: obj?.portfolio
            }
        );
    };
    return (
        <>
            {
                data.map((obj: FundHousePerformanceData, index: number) => {
                    let percentage = 0

                    if (
                        Number.isNaN(Number(obj?.unrelGainLoss ?? 0)) ||
                        Number(obj?.unrelGainLoss ?? 0) === 0 ||
                        Number.isNaN(Number(obj?.investAmount ?? 0)) ||
                        Number(obj?.investAmount ?? 0) === 0
                    ) {
                        percentage = 0
                    } else {
                        // Formula to calculate percentage
                        // ((unrelGainLoss)/investedValue)*100

                        const calculatedPercentage = (Number(obj?.unrelGainLoss ?? 0) / Number(obj?.investAmount ?? 0)) * 100

                        percentage = !Number.isNaN(Number(calculatedPercentage)) ?
                            Math.round((calculatedPercentage) * 100) / 100 : 0
                    }

                    const unrealizedGainLoss = (obj?.unrelGainLoss ?? 0) < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.unrelGainLoss ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: obj?.unrelGainLoss ?? 0, locale, currencyCode })}`

                    return (
                        <TableRow
                            key={`${obj.fundHouseId}-${index}`}
                            sx={(theme: Theme) => ({
                                '& td': {
                                    paddingTop: "15px",
                                    paddingBottom: "15px",
                                    borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
                                },
                                '& td:first-of-type': {
                                    paddingLeft: "0px"
                                },
                            })}
                        >
                            {!isInvestorProfilePage && (
                                <TableCell align="left">
                                    <Typography
                                        variant="body_500"
                                        sx={(theme: Theme) => ({
                                            lineHeight: "20px",
                                            letterSpacing: "0.02px",
                                            color: theme.palette.primary[500],
                                            cursor: "pointer",
                                            '&:hover': {
                                                color: theme.palette.primary[500]
                                            },
                                        })}
                                        onClick={() => handleClientClick(obj)}
                                    >
                                        {obj?.customerName ?? ""}
                                    </Typography>
                                </TableCell>
                            )}
                             {!isInvestorProfilePage && (
                                <TableCell align="center">
                                    <Typography
                                        variant="body_500"
                                        sx={(theme: Theme) => ({
                                            lineHeight: "20px",
                                            letterSpacing: "0.02px",
                                            color: theme.palette.text.primary,
                                        })}
                                    >
                                        {obj?.securityName ?? ""}
                                    </Typography>
                                </TableCell>
                            )}
                            <TableCell align="center">
                                <Typography
                                    variant="body_500"
                                    sx={(theme: Theme) => ({
                                        lineHeight: "20px",
                                        letterSpacing: "0.02px",
                                        color: theme.palette.text.primary,
                                        '&:hover': {
                                            color: theme.palette.primary[500]
                                        },
                                    })}
                                >
                                    {obj?.fundHouseName ?? obj?.issuerName ?? ""}
                                </Typography>
                            </TableCell>
                            <TableCell align="center">
                                <Typography
                                    variant="body_500"
                                    sx={(theme: Theme) => ({
                                        lineHeight: "20px",
                                        letterSpacing: "0.02px",
                                        color: theme.palette.text.primary,
                                    })}
                                >
                                    {formatCurrency({ value: obj?.investAmount ?? 0, locale, currencyCode })}
                                </Typography>
                            </TableCell>
                            <TableCell align="center">
                                <Typography
                                    variant="body_500"
                                    sx={(theme: Theme) => ({
                                        lineHeight: "20px",
                                        letterSpacing: "0.02px",
                                        color: theme.palette.text.primary
                                    })}
                                >
                                    {formatCurrency({ value: obj?.marketValue ?? 0, locale, currencyCode })}
                                </Typography>
                            </TableCell>
                            <TableCell align="center">
                                <Typography
                                    variant="body_500"
                                    sx={(theme: Theme) => ({
                                        lineHeight: "20px",
                                        letterSpacing: "0.02px",
                                        color: (percentage >= 0) ? theme.palette.success[500] : theme.palette.error[500]
                                    })}
                                >
                                    {unrealizedGainLoss} ({percentage}%)
                                </Typography>
                            </TableCell>
                        </TableRow>
                    )
                })
            }
        </>
    )
}